// knb 会强制将分享链接转为 https
import Vue from 'vue'
import Agent from '@zhenguo/jssdk/agent'
import knbUse from '@zhenguo/jssdk/knb/knb-use'
import { processShareConfig, knbConfigShare } from '@zhenguo/jssdk/knb/knb-share'
import { I_SHARECONFIG } from '@zhenguo/jssdk/knb/types'
import { copy } from '@zhenguo/jssdk/clipboard'
import WxShare from './WxShare.vue'
import MpShare from './MpShare.vue'

let wxShareComp: any = null
let mpShareComp: any = null

export function share(_shareConfig: I_SHARECONFIG<any>, shareImageConfig: I_SHARECONFIG<any>) {
  if (Agent.native) {
    const shareConfig = processShareConfig(_shareConfig)
    knbUse('share', shareConfig)
    return
  }
  if (Agent.weixin) {
    knbConfigShare(_shareConfig)
    const VueWxShare = Vue.extend(WxShare)
    if (!wxShareComp) {
      const ele = document.querySelector('body')
      wxShareComp = new VueWxShare()
      wxShareComp.$mount()
      wxShareComp.show()
      ele!.appendChild(wxShareComp.$el)
    } else {
      wxShareComp.show()
    }
    return
  }
  if (shareImageConfig) {
    const VueMpShare = Vue.extend(MpShare)
    if (!mpShareComp) {
      const ele = document.querySelector('body')
      mpShareComp = new VueMpShare()
      mpShareComp.$mount()
      mpShareComp.show(shareImageConfig)
      ele!.appendChild(mpShareComp.$el)
    } else {
      mpShareComp.show(shareImageConfig)
    }
  } else {
    copy(_shareConfig.title + ' ' + _shareConfig.url).then(
      () => {
        window.$toasted.show('邀请链接已复制在剪切板，去分享给好友吧~')
      },
      () => {
        window.$toasted.show('该平台不支持唤起分享')
      },
    )
  }
}
